export const getItem = (key: string, defaultValue?: string) => {
    try {
        const value = window.localStorage.getItem(key);
        return value === null ? defaultValue : value;
    } catch {
        return defaultValue;
    }
};

export const setItem = (key: string, value: string) => {
    try {
        window.localStorage.setItem(key, value);
    } catch {
        return undefined;
    }
};

export const removeItem = (key: string) => {
    try {
        window.localStorage.removeItem(key);
    } catch {
        return undefined;
    }
};

export const hasStorage = (key = 'test') => {
    try {
        window.localStorage.setItem(key, key);
        window.localStorage.removeItem(key);
        return true;
    } catch {
        return false;
    }
};
